import { render, staticRenderFns } from "./deviceOgate.vue?vue&type=template&id=d4fc9974&"
import script from "./deviceOgate.vue?vue&type=script&lang=js&"
export * from "./deviceOgate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports